module.exports = __webpack_public_path__ + "img/external-link.61173be2.svg";